<b3-modal
  [open]="open"
  overlay
  size="md"
  (b3-close)="onModalDismiss()">
  <b3-modal-header
    heading="Alteração detectada!"
    aria-level="2"
    icon="info"
    icon-tone="info"
    close-aria-label="Fechar">
  </b3-modal-header>

  <b3-modal-body>
    <p class="attention-retirement-modal__text">
      Identificamos que a <strong>quantidade de créditos distribuída</strong> entre as entidades foi
      <strong>modificada</strong>.
    </p>
    <p class="attention-retirement-modal__text">
      Revise os dados para garantir que tudo está correto antes de finalizar.
    </p>
  </b3-modal-body>

  <b3-modal-footer>
    <div class="attention-retirement-modal__footer">
      <b3-button
        type="button"
        variant="filled"
        tone="default"
        (b3-click)="onConfirm()">
        <b3-icon name="check_circle" size="sm" tone="on-brand"></b3-icon>
        Entendi
      </b3-button>
    </div>
  </b3-modal-footer>
</b3-modal>
